<div class="relative">
  <div class="flex items-stretch gap-2">
    <div class="relative flex-1">
      <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[20px] !h-5 !w-5 pointer-events-none">location_on</mat-icon>
      <input type="text" [(ngModel)]="postCode" placeholder="Enter postcode" autocomplete="off" (keydown.enter)="onFindYourAddress()"
        class="w-full pl-10 pr-3 py-2.5 rounded-xl border border-gray-200 bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm font-semibold uppercase placeholder:normal-case placeholder:font-normal placeholder:text-gray-400" />
    </div>
    <button type="button" (click)="onFindYourAddress()" [disabled]="!postCode.trim() || searching"
      class="flex items-center gap-1.5 px-5 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap">
      <mat-icon class="!h-[18px] !w-[18px] !text-[18px] !text-amber-400">search</mat-icon> {{ searching ? 'Finding…' : 'Find address' }}
    </button>
  </div>

  @if (notice) {
  <p class="mt-2 flex items-start gap-1.5 text-xs font-medium text-amber-800">
    <mat-icon class="!h-4 !w-4 !text-[16px] shrink-0">info</mat-icon>{{ notice }}
  </p>
  }

  @if (showSuggestions) {
  <div class="absolute left-0 right-0 top-full mt-2 z-50 bg-white rounded-xl border border-gray-200 shadow-xl overflow-hidden">
    @if (addressSuggestions.length > 0) {
    <div class="px-4 py-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400 bg-gray-50 border-b border-gray-100 flex items-center justify-between">
      {{ addressSuggestions.length }} address{{ addressSuggestions.length === 1 ? '' : 'es' }} found
      <button type="button" class="text-gray-400 hover:text-gray-700" (click)="showSuggestions = false" aria-label="Close"><mat-icon class="!h-4 !w-4 !text-[16px]">close</mat-icon></button>
    </div>
    <div class="max-h-64 overflow-y-auto divide-y divide-gray-50">
      @for (address of addressSuggestions; track $index) {
      <button type="button" (click)="onGetAddressDetails(address.Id, address.Text)" class="w-full text-left px-4 py-2.5 text-sm text-gray-800 hover:bg-amber-50 transition-colors">
        <span class="font-medium">{{ address.Text }}</span>
        @if (address.Description) { <span class="block text-xs text-gray-400">{{ address.Description }}</span> }
      </button>
      }
    </div>
    } @else {
    <button type="button" class="w-full text-left px-4 py-3 text-sm text-gray-500 hover:bg-gray-50" (click)="showSuggestions = false">
      No addresses found for that postcode - check it, or type the address in by hand.
    </button>
    }
  </div>
  }
</div>
